var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"home-hero",attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":"","column":"","pa-5":""}},[_c('div',{staticClass:"font-weight-black blue--text text--darken-2 text-center",class:{
        'display-1': _vm.$vuetify.breakpoint.xs,
        'display-2': _vm.$vuetify.breakpoint.sm,
        'display-3':
          _vm.$vuetify.breakpoint.md ||
          _vm.$vuetify.breakpoint.lg ||
          _vm.$vuetify.breakpoint.xl
      }},[_vm._v(" ACCOUNTING ")]),_c('div',{staticClass:"display-3 font-weight-black blue--text text--darken-2 text-center mb-3",class:{
        'display-1': _vm.$vuetify.breakpoint.xs,
        'display-2': _vm.$vuetify.breakpoint.sm,
        'display-3':
          _vm.$vuetify.breakpoint.md ||
          _vm.$vuetify.breakpoint.lg ||
          _vm.$vuetify.breakpoint.xl
      }},[_vm._v(" FOR YOUR BUSINESS ")]),_c('div',{staticClass:"display-0 font-weight-bold blue--text text--darken-2 text-center"},[_vm._v(" Professional accounting services for your business regardless of size or industry ")]),_c('v-btn',{staticClass:"mt-5 blue accent-4",attrs:{"fab":""}},[_c('v-icon',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
          element: '#details-container',
          easing: 'ease-in-out',
          duration: 1000,
          offset: -50
        }),expression:"{\n          element: '#details-container',\n          easing: 'ease-in-out',\n          duration: 1000,\n          offset: -50\n        }"}],attrs:{"large":"","color":"white"}},[_vm._v(" expand_more ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }